export default __webpack_public_path__ + "static/media/Haha.a6a209be.gif";